var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgPayments = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("rect", {
    width: 65.273,
    height: 40.316,
    x: 13,
    y: 24.148,
    fill: "var(--color-neutral-70)",
    rx: 6
  }), React.createElement("path", {
    fill: color,
    d: "M13 31.058h64.934v9.881H13z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.67 31.651h64.273M13.67 41.26h64.273M78.208 44.711V29.56c0-3.071-2.503-5.56-5.591-5.56H19.035c-3.087 0-5.59 2.489-5.59 5.56v29.448c0 3.07 2.503 5.558 5.59 5.558H51.34"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M44.606 54.404H21.799c-.58 0-1.051-.466-1.051-1.041V49.04c0-.575.47-1.042 1.051-1.042h22.807c.58 0 1.051.467 1.051 1.042v4.323c0 .575-.47 1.04-1.051 1.04Z",
    clipRule: "evenodd"
  }), React.createElement("circle", {
    cx: 68.59,
    cy: 59.08,
    r: 12.66,
    fill: color,
    stroke: borderColor,
    strokeWidth: 1.5
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m71.065 58.075 3.046-3.142m0 0-3.046-2.951m3.046 2.951H63.067M66.287 59.725l-3.22 3.108m0 0 3.22 2.998m-3.22-2.998 11.044.04"
  }));
};
export default SvgPayments;